import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { setFileData } from '../../api/features/fileSlice'
import DocumentTypeRadioButton from '../inputs/DocumentTypeRadioButton'

const resetReturnReceipt = (fileData) => ({
  expectsReturnReceipt: false,
  returnReceiptReminderDays: fileData.returnReceiptReminderDays ?? 14,
})

const DocumentTypeForm = ({ setPageState }) => {
  const fileData = useSelector((state) => state.file.fileData)

  const dispatch = useDispatch()

  const { t } = useTranslation()

  const handleRecieved = () => {
    dispatch(
      setFileData({
        issued: false,
        inSlide: false,
        outSlide: false,
        koDoc: false,
        advanced: false,
        reExport: false,
        reciedved: !fileData.reciedved,
        ...resetReturnReceipt(fileData),
      }),
    )
  }
  const handleIssued = () => {
    const nextIssued = !fileData.issued
    dispatch(
      setFileData({
        issued: nextIssued,
        inSlide: false,
        outSlide: false,
        koDoc: false,
        advanced: false,
        reciedved: false,
        reExport: false,
        ...(nextIssued ? {} : resetReturnReceipt(fileData)),
      }),
    )
  }
  return (
    <div className="flex gap-4 border-b border-neutral">
      {/* Recieved */}
      <DocumentTypeRadioButton checked={fileData?.reciedved} onChange={handleRecieved} title={t('received')} />

      {/* Issued */}
      <DocumentTypeRadioButton checked={fileData?.issued} title={t('clasified')} onChange={handleIssued} />
    </div>
  )
}

export default DocumentTypeForm
